import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-website-card-title',
  templateUrl: './website-card-title.component.html',
})
export class WebsiteCardTitleComponent {
  @Input() data
  @Output() page = new EventEmitter()
  @Input() defaultClass
}
